<template>
  <div>
    <div class="page-head">
      <div>
        <h2>定制需求</h2>
        <p>处理用户提交的高端定制、目的地定制等需求。</p>
      </div>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="姓名/来源/联系人/想去地点/备注" clearable /></el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="待处理" value="pending" />
            <el-option label="已分配" value="assigned" />
            <el-option label="规划中" value="planning" />
            <el-option label="已完成" value="completed" />
            <el-option label="已取消" value="cancelled" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="需求名称" min-width="180" />
        <el-table-column label="来源" width="150"><template slot-scope="{ row }">{{ sourceText(row) }}</template></el-table-column>
        <el-table-column prop="travel_date" label="出行日期" width="130" />
        <el-table-column label="人数" width="120"><template slot-scope="{ row }">{{ peopleText(row) }}</template></el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="110" />
        <el-table-column prop="contact_phone" label="联系电话" width="130" />
        <el-table-column prop="must_visit" label="想去地点" min-width="220" show-overflow-tooltip />
        <el-table-column prop="status" label="处理状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.status" /></template></el-table-column>
        <el-table-column label="操作" width="120" fixed="right"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">处理</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog title="处理定制需求" :visible.sync="drawerVisible" width="600px" destroy-on-close>
      <el-form class="drawer-form" :model="form" label-width="120px">
        <el-form-item label="需求名称"><el-input v-model="form.name" disabled /></el-form-item>
        <el-form-item label="来源"><el-input :value="sourceText(form)" disabled /></el-form-item>
        <el-form-item label="来源标题"><el-input v-model="form.source_title" disabled /></el-form-item>
        <el-form-item label="出行日期"><el-input v-model="form.travel_date" disabled /></el-form-item>
        <el-form-item label="人数"><el-input :value="peopleText(form)" disabled /></el-form-item>
        <el-form-item label="联系人"><el-input v-model="form.contact_name" /></el-form-item>
        <el-form-item label="联系电话"><el-input v-model="form.contact_phone" /></el-form-item>
        <el-form-item label="想去地点"><el-input v-model="form.must_visit" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="酒店偏好"><el-input v-model="form.hotel_level" /></el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="form.status">
            <el-option label="待处理" value="pending" />
            <el-option label="已分配" value="assigned" />
            <el-option label="规划中" value="planning" />
            <el-option label="已完成" value="completed" />
            <el-option label="已取消" value="cancelled" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责员工ID"><el-input-number v-model="form.assigned_admin_id" :min="0" /></el-form-item>
        <el-form-item label="补充备注"><el-input v-model="form.extra_note" type="textarea" :rows="5" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存处理结果</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import { listResource, updateResource } from "../api/resources";

export default {
  name: "CustomDemandsManage",
  components: { PagedTable, StatusTag },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: {}
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    peopleText(row) {
      const adult = Number(row.adult_count || 0);
      const child = Number(row.child_count || 0);
      const elder = Number(row.elder_count || 0);
      return `${adult}成人 / ${child}儿童 / ${elder}老人`;
    },
    sourceText(row) {
      if (!row) return "-";
      const map = {
        custom_demand_form: "高端定制",
        route_plan: "方案模板",
        route: "线路",
        mini_program: "小程序"
      };
      const base = map[row.source] || row.source || "-";
      return row.source_title ? `${base}：${row.source_title}` : base;
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("custom-demands", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openEdit(row) {
      this.form = { ...row, assigned_admin_id: Number(row.assigned_admin_id || 0) };
      this.drawerVisible = true;
    },
    async save() {
      this.saving = true;
      try {
        await updateResource("custom-demands", this.form.id, this.form);
        this.$message.success("定制需求处理结果已保存");
        this.drawerVisible = false;
        this.fetchList();
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
